export enum DayTime {
	morning = 'morning',
	afternoon = 'afternoon',
	evening = 'evening',
	night = 'night',
}
